'use client';
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSession = exports.signOut = exports.signIn = exports.useSession = exports.useScopes = exports.SessionProvider = exports.AuthGate = exports.getProviders = exports.getCsrfToken = void 0;
var react_1 = require("next-auth/react");
Object.defineProperty(exports, "getCsrfToken", { enumerable: true, get: function () { return react_1.getCsrfToken; } });
Object.defineProperty(exports, "getProviders", { enumerable: true, get: function () { return react_1.getProviders; } });
var components_1 = require("./components");
Object.defineProperty(exports, "AuthGate", { enumerable: true, get: function () { return components_1.AuthGate; } });
Object.defineProperty(exports, "SessionProvider", { enumerable: true, get: function () { return components_1.SessionProvider; } });
var useScopes_1 = require("./hooks/useScopes");
Object.defineProperty(exports, "useScopes", { enumerable: true, get: function () { return useScopes_1.useScopes; } });
var useSession_1 = require("./hooks/useSession");
Object.defineProperty(exports, "useSession", { enumerable: true, get: function () { return useSession_1.useSession; } });
var signIn_1 = require("./signIn");
Object.defineProperty(exports, "signIn", { enumerable: true, get: function () { return signIn_1.signIn; } });
var signOut_1 = require("./signOut");
Object.defineProperty(exports, "signOut", { enumerable: true, get: function () { return signOut_1.signOut; } });
var get_session_1 = require("./utils/get-session");
Object.defineProperty(exports, "getSession", { enumerable: true, get: function () { return get_session_1.getSession; } });
